<template>
    <v-form
            v-model="valid"
            ref="apikeyform"
            lazy-validation
            @submit.prevent="onSubmit"
            @keyup.native.enter="onSubmit"
    >
        <v-card
                :loading="loading"
                :disabled="loading"
        >
            <v-card-title>
                API-keys
            </v-card-title>

            <v-card-subtitle>
                Cross-server keys
            </v-card-subtitle>

            <v-card-text>

                <v-text-field
                        v-model="values.public_key"
                        label="API Public Key"
                        :disabled="loading"
                        :rules="[rules.required]"
                        outlined
                        append-icon="mdi-sync"
                        @click:append="generateKey('public_key', 'pkey')"
                >
                </v-text-field>

                <v-text-field
                        v-model="values.secret_key"
                        label="API Secret Key"
                        :disabled="loading"
                        :rules="[rules.required]"
                        outlined
                        append-icon="mdi-sync"
                        @click:append="generateKey('secret_key', 'skey')"
                ></v-text-field>

                <v-text-field
                        v-model="values.url"
                        label="Service Server URL"
                        :disabled="loading"
                        :rules="rules.url"
                        outlined
                ></v-text-field>

            </v-card-text>

            <v-card-actions class="px-4 pb-5">

                <v-btn
                        :loading="loading"
                        :disabled="loading"
                        @click="test"
                >
                    Send test
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn
                        color="success"
                        :loading="loading"
                        :disabled="loading"
                        type="submit"
                >
                    Save
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>
    export default {
        name: 'OptionsApiKeys',
        data(){
            return {
                loading: false,
                valid: false,
                rules      : {
                    required : value => !!value || 'Required field.',
                    url: [
                        (v) => !!v || 'URL is required',
                        (v) => this.isValidUrl(v) || 'URL must be valid'
                    ]
                },
                values:{
                    public_key: null,
                    secret_key: null,
                    url: null,
                }
            }
        },
        created() {
            this.get();
        },
        methods:{

            isValidUrl(str){
                let pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
                    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
                    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
                    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
                    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
                return !!pattern.test(str);
            },

            get(){
                this.loading = true;

                this.axios.post('options/apiKeys', JSON.stringify( {
                    method: 'show',
                } ) )
                .then((response)=>{

                    const params = response.data;

                    if ( params.status === 'success' ) {
                        this.values    = params.data.values;
                    } else {
                        this.$emit('alert', {type:'error', message: params.message});
                    }
                    this.loading = false;

                }).catch((reject)=>{
                    this.$emit('alert', {type:'error', message: 'Data has not been received'});
                    console.log(reject);
                    this.loading = false;
                });
            },

            onSubmit(){
                if( this.$refs.apikeyform.validate() ) {
                    this.save();
                }
            },

            save(){
                this.loading = true;

                this.axios.post( 'options/apiKeys', JSON.stringify( {
                    method: 'edit',
                    data: this.values
                } ) ).then( (response) => {

                    let params = response.data;

                    if( params.status === 'success' ) {
                        this.$emit('alert', {type:'success', message: params.message});
                    }else {
                        this.$emit('alert', {type:'error', message: params.message});
                    }
                    this.loading = false;

                } ).catch( (reject) => {
                    this.$emit('alert', {type:'error', message: 'Data has not been received'});
                    console.log(reject);
                    this.loading = false;
                } );
            },

            generateKey( field, prefix = ''){
                this.loading = true;

                this.axios.post( 'options/apiKeys', JSON.stringify( {
                    method: 'generate',
                    data: {
                        prefix: prefix
                    }
                } ) ).then( (response) => {

                    let params = response.data;

                    if( params.status === 'success' ) {
                        this.values[ field ] = params.data.key;
                        this.$emit('alert', {type:'success', message: params.message});
                    }else {
                        this.$emit('alert', {type:'error', message: params.message});
                    }
                    this.loading = false;

                } ).catch( (reject) => {
                    this.$emit('alert', {type:'error', message: 'Data has not been received'});
                    console.log(reject);
                    this.loading = false;
                } );
            },

            test(){

                this.loading = true;

                this.axios.post( 'options/apiKeys', JSON.stringify( {
                    method: 'test',
                } ) ).then( (response) => {

                    let params = response.data;

                    if( params.status === 'success' ) {
                        this.$emit('alert', {type:'success', message: params.message});
                    }else {
                        this.$emit('alert', {type:'error', message: params.message});
                    }
                    this.loading = false;

                } ).catch( (reject) => {
                    this.$emit('alert', {type:'error', message: 'Data has not been received'});
                    console.log(reject);
                    this.loading = false;
                } );
            },
        }
    }
</script>